import { decodeHTML } from 'entities';
import { useEffect, useState } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { deleteMABAA102, postMABAA100active, postMABAA100unactive } from '../../../services/Api';
import Pagination from '../../../shared/components/Pagination';
import { MESSAGE } from '../../../shared/constants/app';
import { formatDate, formatNumberWithCommas } from '../../../utils';

const MABAA100 = () => {
    const { id } = useParams();

    const [searchParams] = useSearchParams();
    const pageActive = Number(searchParams.get('page-active')) || 1;
    const pageUnactive = Number(searchParams.get('page-unactive')) || 1;
    const [pagesActive, setPagesActive] = useState({});
    const [dataActive, setDataActive] = useState([]);
    const [pagesUnActive, setPagesUnActive] = useState({});
    const [dataUnActive, setDataUnActive] = useState([]);

    useEffect(() => {
        postMABAA100active(id, { page: pageActive })
            .then(({ data }) => {
                setDataActive(data.data);
                setPagesActive(data.info);
            })
            .catch((error) => console.log(error));
    }, [id, pageActive]);

    useEffect(() => {
        postMABAA100unactive(id, { page: pageUnactive })
            .then(({ data }) => {
                setDataUnActive(data.data);
                setPagesUnActive(data.info);
            })
            .catch((error) => console.log(error));
    }, [id, pageUnactive]);

    const deleteDataUnactive = async (seq) => {
        if (window.confirm(MESSAGE.confirm.delete)) {
            try {
                await deleteMABAA102(seq);
                window.alert(MESSAGE.notify.deleteSuccess);

                const { data } = await postMABAA100unactive(id, { page: pageUnactive });
                setDataUnActive(data.data);
                setPagesUnActive(data.info);
            } catch (error) {
                console.log(error);
                window.alert(MESSAGE.notify.deleteError);
            }
        }
    };

    return (
        <div className="profile-content">
            <div className="title-profile">채용공고 등록 내역</div>
            <div id="profile-payment-history">
                <div className="title-table">진행중인 채용광고</div>
                <div className="profile-content-count">
                    총 <span className="total">{formatNumberWithCommas(pagesActive?.totalRow || 0)}</span>건
                </div>
                <table className="table-gray">
                    <thead>
                        <tr>
                            <th style={{ width: '4%' }} />
                            <th style={{ width: '22%' }}>제목</th>
                            <th style={{ width: '6%' }}>온라인접수</th>
                            <th style={{ width: '6%' }}>담당자명</th>
                            <th style={{ width: '6%' }}>시작일</th>
                            <th style={{ width: '6%' }}>종료일</th>
                            <th style={{ width: '4%' }}>조회수</th>
                            <th style={{ width: '6%' }}>등록일</th>
                            <th style={{ width: '6%' }}>수정일</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataActive && dataActive.length > 0 ? (
                            dataActive.map((item, index) => (
                                <tr key={'active-' + index}>
                                    <td>{item?.seq}</td>
                                    <td>{item?.title}</td>
                                    <td>{item?.applyMethod1 === '001' ? '가능' : '불가능'}</td>
                                    <td>{item?.charge}</td>
                                    <td>{formatDate(item?.recruitFrom)}</td>
                                    <td>{formatDate(item?.recruitEnd)}</td>
                                    <td>{item?.visitedCnt}</td>
                                    <td>{formatDate(item?.addDate)}</td>
                                    <td>{formatDate(item?.modDate)}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={10}>데이타가 없습니다.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <Pagination pages={pagesActive} params="page-active" />

            <div id="profile-payment-history">
                <div className="title-table">종료된 채용광고</div>
                <small className='blue'>
                    상태구분: K : 보관, O : 진행, C : 채용마감(회원), E : 기간마감(시스템), D : 삭제, P : 입금대기, V :
                    승인대기, W : 등록대기, X : 미결제삭제.
                </small>
                <div className="profile-content-count">
                    총 <span className="total">{formatNumberWithCommas(pagesUnActive?.totalRow || 0)}</span>건
                </div>
                <table className="table-gray">
                    <thead>
                        <tr>
                            <th style={{ width: '4%' }} />
                            <th style={{ width: '5%' }}>Seq</th>
                            <th style={{ width: '31%' }}>제목</th>
                            <th style={{ width: '7%' }}>온라인접수</th>
                            <th style={{ width: '6%' }}>담당자명</th>
                            <th style={{ width: '5%' }}>시작일</th>
                            <th style={{ width: '5%' }}>종료일</th>
                            <th style={{ width: '5%' }}>조회수</th>
                            <th style={{ width: '6%' }}>등록일</th>
                            <th style={{ width: '6%' }}>수정일</th>
                            <th style={{ width: '4%' }}>상태</th>
                            <th style={{ width: '6%' }}>마감일</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataUnActive && dataUnActive.length > 0 ? (
                            dataUnActive.map((item, index) => (
                                <tr key={'unactive-' + index}>
                                    <td>
                                        {(item?.statusFlag === 'E' ||
                                            item?.statusFlag === 'C') && (
                                                <button type="button" onClick={() => deleteDataUnactive(item.seq)}>
                                                    삭제
                                                </button>
                                            )}
                                    </td>
                                    <td>{item?.seq}</td>
                                    <td>{decodeHTML(item?.title)}</td>
                                    <td>{item?.applyMethod1 === '001' ? '가능' : '불가능'}</td>
                                    <td>{item?.charge}</td>
                                    <td>{formatDate(item?.recruitFrom)}</td>
                                    <td>{formatDate(item?.recruitEnd)}</td>
                                    <td>{item?.visitedCnt}</td>
                                    <td>{formatDate(item?.addDate)}</td>
                                    <td>{formatDate(item?.modDate)}</td>
                                    <td>{item?.statusFlag}</td>
                                    <td>{formatDate(item?.changeDate)}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={12}>데이타가 없습니다.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <Pagination pages={pagesUnActive} params="page-unactive" />
        </div>
    );
};

export default MABAA100;
